
import { Vue, Options } from 'vue-class-component'
let instanceCounter = 0
@Options({ name: 'Key2', props: { width: { type: [Number, String], default: 56 }, height: { type: [Number, String], default: 40 } } })
export default class Key2 extends Vue {
  private instanceId = `key2-${++instanceCounter}`
  get glossId(): string { return `${this.instanceId}-gloss` }
  get highlightId(): string { return `${this.instanceId}-highlight` }
}
